import React, { ReactElement } from 'react';

import { dividerDisplayName } from './Divider.qa';

export function OzDivider (): ReactElement {
    return (
        <hr
            className='h-px bg-black-30 border-none my-3'
        >
        </hr>
    );
}

OzDivider.displayName = dividerDisplayName;
